import i18next from 'i18next';

const roundDownToFixed = (value: number, decimals: number) => {
  const factor = Math.pow(10, decimals);
  return Math.floor(value * factor) / factor;
};

const formatNumber = (value: number, options?: Intl.NumberFormatOptions): string =>
  new Intl.NumberFormat(i18next.language, options).format(value);

export const compactNumber = (value: number): string => {
  // I'd love to use Intl.NumberFormat with notation:'compact', but it doesn't seem to support compact
  // numbers in the polyfill we have.
  // return new Intl.NumberFormat(i18n.language, { notation: 'compact' }).format(value);

  const units: [number, string][] = [
    [1_000, 'K'],
    [1_000_000, 'M'],
    [1_000_000_000, 'B'],
    // I hope to need T someday.
  ];

  // Not Array.prototype.findLast: some consumers (galatea-web) compile with a lib below ES2023.
  const unit = [...units].reverse().find(([threshold]) => value >= threshold);

  // If the value is less than the smallest unit (1K), return it unchanged.
  if (!unit) {
    return formatNumber(value);
  }

  const unitValue = value / unit[0];
  const wholeNumberPart = Math.floor(unitValue);
  const shouldShowDecimal = wholeNumberPart < 100;
  const roundedValue = shouldShowDecimal ? roundDownToFixed(unitValue, 1) : Math.floor(unitValue);

  return (
    formatNumber(roundedValue, {
      minimumFractionDigits: shouldShowDecimal ? 1 : 0,
      maximumFractionDigits: shouldShowDecimal ? 1 : 0,
    }) + unit[1]
  );
};
